import React, { Component, PropTypes } from 'react';
import { Row, Col } from 'react-bootstrap';
import './unsubscribed.scss'

export default class Unsubscribed extends Component {

  static contextTypes = {
    location: PropTypes.object.isRequired
  };

  render () {
    return <Row className="unsubscribed">
      <Col xs={12}>
        <div>You have been unsubscribed from this list. You can re-subscribe at anytime through your Profile settings.</div>
      </Col>
    </Row>;
  }

}



// WEBPACK FOOTER //
// ./src/views/unsubscribed.jsx